import { render, staticRenderFns } from "./diffPressure.vue?vue&type=template&id=f38faac4&scoped=true"
import script from "./diffPressure.vue?vue&type=script&lang=js"
export * from "./diffPressure.vue?vue&type=script&lang=js"
import style0 from "./diffPressure.vue?vue&type=style&index=0&id=f38faac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38faac4",
  null
  
)

export default component.exports